import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{}>;

type State = {
    sort: SortDescriptor[];
    Classrooms: ClassroomData[];
    isLoading: boolean;
}

export interface ClassroomData {
    ClassroomId: number;
    FacilityID: number;
    RoomName: string;
    RoomId: string;
}

class RoomNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/classroom/${this.props.dataItem.ClassroomId}`}>
                    {this.props.dataItem.RoomName}
                </Link>
            </td>
        );
    }
}

class RoomIdCell extends GridCell {
    render() {
        return (
            <td>{this.props.dataItem.RoomId}</td>
        );
    }
}

class FacilityNameCell extends GridCell {
    render() {
        return (
            <td>
                <Link style={{ color: '#007bff' }} to={`/facility/${this.props.dataItem.FacilityID}`}>
                    {this.props.dataItem.FacilityName}
                </Link>
            </td>
        );
    }
}

class Classrooms extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Classrooms: [],
            isLoading: false,
            sort: [],
        };
        this.sortChange = this.sortChange.bind(this);
    }

    public componentWillMount() {
        this.getClassrooms();
    }

    public render() {
        return <React.Fragment>
            {this.state.isLoading && <LoadingPanel />}
            <DocumentTitle title="Classrooms" />
            <div className="row">
                <div className="col">
                    <h1>Classrooms</h1>
                </div>
                <div className="col">
                    <Link
                        role="button"
                        className="btn btn-primary float-right"
                        to={'/classroom/0'}
                    >
                        Add Classroom
                    </Link>
                </div>
            </div>
            <Grid data={this.state.Classrooms}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
            >
                <Column field="RoomName" title="Name" cell={RoomNameCell} />
                <Column field="RoomId" title="Room Id" cell={RoomIdCell} />
                <Column field="FacilityName" title="Facility" cell={FacilityNameCell} />
            </Grid>
            <br />
        </React.Fragment>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            Classrooms: orderBy(this.state.Classrooms, event.sort)
        });
    }

    private getClassrooms() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        this.setState({ isLoading: true });
        fetchApi('api/Classrooms/List', data, 'POST')
            .then((data: ClassroomData[]) => {
                this.setState({ Classrooms: data, isLoading: false });
            });
    }
}

export default Classrooms;
